import { createContext, type ReactNode, useContext } from "react";

type ViewType = "home" | "stories";

interface IStoriesViewCtx {
  view: ViewType;
}

const initState: IStoriesViewCtx = {
  view: "stories",
};

const StoriesViewCtx = createContext<IStoriesViewCtx>(initState);

interface IProps {
  children: ReactNode;
  view: ViewType;
}

export const StoriesViewCtxProvider = ({ children, view }: IProps) => {
  return (
    <StoriesViewCtx.Provider
      value={{
        view,
      }}
    >
      {children}
    </StoriesViewCtx.Provider>
  );
};

export const useStoriesViewCtx = () => {
  const ctx = useContext(StoriesViewCtx);
  if (!ctx) {
    throw new Error(
      "useStoriesViewCtx must be used within a StoriesViewCtxProvider",
    );
  }
  return ctx;
};
